import { useMemo, useState } from 'react';
import { Spinner, } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import BreadCrumb from '../Common/BreadCrumb';
import NavHeader from '../Common/NavHeader';
import { useGetRestaurantsCategoriesDetails } from './api';
import { useNavigate } from 'react-router-dom';

const ManageCBCategories = () => {
    const { data, isLoading, isError } = useGetRestaurantsCategoriesDetails();
    const [searchText, setSearchText] = useState("");

    // Safely filter data based on search text
    const filteredData = useMemo(() => {
        if (!data) return {};
        if (!searchText.trim()) return data;

        const lowerSearch = searchText.toLowerCase();

        return Object?.fromEntries(
            Object?.entries(data).filter(([rest_id, rest]) =>
                rest?.restaurant_name?.toLowerCase().includes(lowerSearch)
            )
        );
    }, [data, searchText]);
    const navigate = useNavigate()
    return (
        <>
            <ToastContainer />
            <NavHeader view="" />
            <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
                <BreadCrumb
                    text="Home > Manage CB Categories"
                    showDatePicker={false}
                >
                    <input
                        className="form-control"
                        value={searchText}
                        style={{
                            width: "290px",
                            maxWidth: "100%",
                            height: "40px",
                            borderRadius: "5px"
                        }}
                        placeholder="Search Restaurant Name..."
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                </BreadCrumb>

                {isLoading ? <div className="d-flex justify-content-center align-items-center">
                    <Spinner animation="border" variant="primary" />
                </div> : <div style={{ maxHeight: "32rem", overflowY: "auto" }}>
                    <table className="table table-striped  table-bordered shadow-sm table-responsive table-stack">
                        <thead>
                            <tr style={{ position: "sticky", top: -1 }}>
                                <th>Restaurant Name</th>
                                <th>Active Categories</th>
                                <th>Inactive Categories</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan={3} className="text-center">

                                        <div className="d-flex justify-content-center align-items-center">
                                            <Spinner animation="border" variant="primary" />
                                        </div>
                                    </td>
                                </tr>
                            ) : Object?.keys(filteredData)?.length === 0 ? (
                                <tr>
                                    <td colSpan={3} className="text-center">No restaurants found</td>
                                </tr>
                            ) : (
                                Object?.keys(filteredData)?.map((rest_id, index) => {
                                    const restaurant = filteredData?.[rest_id] || {};
                                    const activeCategories = restaurant?.active_categories || {};
                                    const inactiveCategories = restaurant?.inactive_categories || {};

                                    return (
                                        <tr key={index} onClick={() => navigate(`/manage-cb-categories/${rest_id}?restaurant_name=${restaurant?.restaurant_name}`)} style={{ cursor: "pointer" }}>
                                            <td data-label="Restaurant Name" style={{ width: "20%", verticalAlign: "top" }}>
                                                <a

                                                    // href="#"
                                                    data-toggle="tooltip"
                                                    title={rest_id}
                                                    className="text-body"
                                                    style={{
                                                        textDecoration: "none",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    {restaurant?.restaurant_name || "-"}
                                                </a>
                                            </td>

                                            <td data-label="Active Categories" className="stack-full" style={{ width: "40%", verticalAlign: "top" }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        fontSize: "12px",
                                                        maxHeight: "180px",
                                                        overflowY: "auto",
                                                        gap: "10px",
                                                        padding: "4px",
                                                    }}
                                                >
                                                    {Object.keys(activeCategories).map((groupKey, idx) => {
                                                        const group = activeCategories[groupKey];
                                                        if (!group || Object.keys(group).length === 0) return null;

                                                        return (
                                                            <div key={idx} style={{ textAlign: "start" }}>
                                                                {/* Group Heading */}
                                                                <div
                                                                    style={{
                                                                        fontWeight: "600",
                                                                        fontSize: "13px",
                                                                        marginBottom: "4px",
                                                                        borderBottom: "1px solid #eee",
                                                                        paddingBottom: "2px",
                                                                    }}
                                                                >
                                                                    {groupKey.charAt(0).toUpperCase() + groupKey.slice(1)}
                                                                </div>

                                                                {/* Category Pills */}
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        flexWrap: "wrap",
                                                                        gap: "6px",
                                                                    }}
                                                                >
                                                                    {Object.entries(group).map(([catId, catName], i) => (
                                                                        <span
                                                                            key={i}
                                                                            className="bg-body-tertiary"
                                                                            style={{
                                                                                padding: "3px 8px",
                                                                                border: "1px solid #ddd",
                                                                                borderRadius: "20px",
                                                                                fontSize: "11px",
                                                                                whiteSpace: "nowrap",
                                                                            }}
                                                                        >
                                                                            {catName}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </td>
                                            <td data-label="Inactive Categories" className="stack-full" style={{ width: "40%", verticalAlign: "top" }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        fontSize: "12px",
                                                        maxHeight: "180px",
                                                        overflowY: "auto",
                                                        gap: "10px",
                                                        padding: "4px",
                                                    }}
                                                >
                                                    {Object.keys(inactiveCategories).map((groupKey, idx) => {
                                                        const group = inactiveCategories[groupKey];
                                                        if (!group || Object.keys(group).length === 0) return null;

                                                        return (
                                                            <div key={idx} style={{ textAlign: "start" }}>
                                                                {/* Group Heading */}
                                                                <div
                                                                    style={{
                                                                        fontWeight: "600",
                                                                        fontSize: "13px",
                                                                        marginBottom: "4px",
                                                                        borderBottom: "1px solid #eee",
                                                                        paddingBottom: "2px",
                                                                    }}
                                                                >
                                                                    {groupKey.charAt(0).toUpperCase() + groupKey.slice(1)}
                                                                </div>

                                                                {/* Category Pills */}
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        flexWrap: "wrap",
                                                                        gap: "6px",
                                                                    }}
                                                                >
                                                                    {Object.entries(group).map(([catId, catName], i) => (
                                                                        <span
                                                                            key={i}
                                                                            style={{
                                                                                padding: "3px 8px",
                                                                                border: "1px solid #ddd",
                                                                                borderRadius: "20px",
                                                                                // background: "#fff4f4", // light red-ish background for inactive
                                                                                fontSize: "11px",
                                                                                whiteSpace: "nowrap",
                                                                                // color: "#c0392b", // darker red text
                                                                            }}
                                                                        >
                                                                            {catName}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </td>

                                        </tr>
                                    )
                                })
                            )}
                        </tbody>
                    </table>
                </div>}
            </div>
        </>
    )
}

export default ManageCBCategories;
